import React, { useEffect, useRef } from 'react'

import Marketo from '../marketo'
import Typography from '../typography'
import { SubscribeContainer } from './style'

export default function subscribeModal(props: any) {
  if (props.data) {
    const landingModalHeadline = props.data.landingModalHeadline
      ? props.data.landingModalHeadline
      : ''

    const landingModalSubheadline = props.data.landingModalSubheadline
      ? props.data.landingModalSubheadline
      : ''

    const successHeadline = props.data.successHeadline ? props.data.successHeadline : ''

    const successMessage =
      props.data.successMessage && props.data.successMessage.successMessage
        ? props.data.successMessage.successMessage
        : ''

    const modalRef = useRef<HTMLDivElement>(null)

    const handleOpen = () => {
      if (modalRef && modalRef.current) {
        modalRef.current.classList.add('SubscribeModal--Visible')
      }
    }

    const handleClose = () => {
      if (modalRef && modalRef.current) {
        modalRef?.current?.classList.remove('SubscribeModal--Visible')
        sessionStorage.setItem('subscribeModalClosed', 'true')
      }
    }

    const blogFormSuccessHandler = (form: any) => {
      if (window && window.hasOwnProperty('MktoForms2')) {
        form.onSuccess(function (vals: any, thanksURL: any) {
          form.getFormElem().hide()
          sessionStorage.setItem('formSubmitted', 'true')
          modalRef?.current?.classList.add('formSubmitted')
          return false
        })
      }
    }

    function getScrollPercent() {
      const scrolledAmount =
        window.pageYOffset ||
        document.scrollingElement?.scrollTop ||
        document.documentElement?.scrollTop ||
        document.body?.scrollTop ||
        0

      const scrollableAmount =
        (document.documentElement?.scrollHeight || document.body?.scrollHeight) -
        document.documentElement?.clientHeight

      return (scrolledAmount / scrollableAmount) * 100
    }

    useEffect(() => {
      if (typeof window !== 'undefined' && sessionStorage?.getItem('formSubmitted')) {
        modalRef?.current?.classList.add('formSubmitted')
      }
    }, [])

    useEffect(() => {
      const allModalTriggers = document.querySelectorAll('.SubscribeModal__Trigger')

      for (let i = 0; i < allModalTriggers.length; i++) {
        allModalTriggers[i].addEventListener('click', e => {
          e.preventDefault()
          handleOpen()
        })
      }

      document.addEventListener('scroll', e => {
        if (getScrollPercent() >= 40) {
          if (
            !sessionStorage?.getItem('formSubmitted') &&
            !sessionStorage?.getItem('subscribeModalClosed')
          ) {
            handleOpen()
          }
        }
      })
    }, [])

    return (
      <SubscribeContainer ref={modalRef} data-cy="SubscribeModal">
        <div>
          {landingModalHeadline && (
            <Typography className="SubscribeModal__Headline" type="header5">
              {landingModalHeadline}
            </Typography>
          )}

          {landingModalSubheadline && (
            <Typography className="SubscribeModal__Subheadline" type="bodyXS">
              {landingModalSubheadline}
            </Typography>
          )}

          {props.data.marketoForm && (
            <>
              {successMessage && (
                <div className="SubscribeModal__Confirm">
                  {successHeadline && <Typography type="header3">{successHeadline}</Typography>}
                  {successMessage && (
                    <Typography className="SubscribeModal__SuccessMessage" type="body">
                      {successMessage}
                    </Typography>
                  )}
                </div>
              )}
              <Marketo formData={props.data.marketoForm} formCallbacks={blogFormSuccessHandler} />
            </>
          )}
        </div>

        <svg
          width="18"
          height="18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="SubscribeModal__Close-Icon"
          data-cy="SubscribeModal__Close-Icon"
          onClick={handleClose}>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.293.293a1 1 0 1 1 1.414 1.414L10.414 9l7.293 7.293a1 1 0 0 1-1.414 1.414L9 10.414l-7.293 7.293a1 1 0 0 1-1.414-1.414L7.586 9 .293 1.707A1 1 0 0 1 1.707.293L9 7.586 16.293.293Z"
            fill="#fff"
          />
        </svg>
      </SubscribeContainer>
    )
  }
  return null
}
